export const withInstall = (main, extra) => {
  const installable = main;

  installable.install = (app) => {
    const components = [main, ...Object.values(extra ?? {})];
    components.forEach((comp) => {
      if (comp?.name) {
        app.component(comp.name, comp);
      }
    });
  };

  if (extra) {
    Object.entries(extra).forEach(([key, comp]) => {
      installable[key] = comp;
    });
  }

  return installable;
};

export const withInstallFunction = (fn, name) => {
  const installable = fn;

  installable.install = (app) => {
    installable._context = app._context;
    app.config.globalProperties[name] = fn;
  };

  return installable;
};

export const withInstallFunctionNames = (fn, names) => {
  const installable = fn;

  installable.install = (app) => {
    installable._context = app._context;
    names.forEach((name) => {
      app.config.globalProperties[name] = fn;
    });
  };

  return installable;
};

export const withInstallDirective = (directive, name) => {
  const installable = directive;

  installable.install = (app) => {
    app.directive(name, directive);
  };

  return installable;
};

